import { render, staticRenderFns } from "./OnLineView.vue?vue&type=template&id=c97bb42a&scoped=true&"
import script from "./OnLineView.vue?vue&type=script&lang=js&"
export * from "./OnLineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97bb42a",
  null
  
)

export default component.exports